import convertWeeklyWorkedTimeToNumberOfHours from './convertWeeklyWorkedTimeToNumberOfHours';

export default (record) => {
  const duration = convertWeeklyWorkedTimeToNumberOfHours(record);
  return duration === 35 ? 8 : (duration / 3).toFixed(2);
};
